//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const DELETE_MESSAGE = "delete/message";

// Ecommerce
// Product
export const GET_PRODUCTS = "/apps/product";
export const GET_PRODUCTS_DETAIL = "/apps/productDetail";

// Orders
export const GET_ORDERS = "/apps/order";
export const ADD_NEW_ORDER = "/apps/order";
export const UPDATE_ORDER = "/apps/order";
export const DELETE_ORDER = "/apps/order";

// Customers
export const GET_CUSTOMERS = "/apps/customer";
export const ADD_NEW_CUSTOMER = "/apps/customer";
export const UPDATE_CUSTOMER = "/apps/customer";
export const DELETE_CUSTOMER = "/apps/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//cart

export const GET_CART = "/cart";
export const DELETE_CART = "/delete-cart";

//CRYPTO
export const GET_WALLET = "/wallet";
//activities
export const GET_WALLET_ACTIVITIES = "wallet-activies";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/projects";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Task
export const GET_TASKS = "/apps/task";
export const ADD_TASKS = "/add/task";
export const UPDATE_TASKS = "/update/task";
export const DELETE_TASKS = "/delete/task";

//CONTACTS
export const GET_USERS = "/apps/users";
export const ADD_NEW_USERS = "/apps/users";
export const UPDATE_USERS = "/apps/users";
export const DELETE_USERS = "/delete/users/";
export const GET_USER_PROFILE = "/user";

// Contact
export const GET_CONTACTS = "/apps/contact";

// Crypto
export const GET_CRYPTO_ORDRER_LIST = "/crypto-order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const GET_INVOICE_DETAIL = "/apps/invoice-detail";

//Mails
export const GET_INBOX_MAILS = "/mailslists";
export const SELECT_FOLDER = "/folders";
export const GET_SELECTE_MAIL = "/seelctMail";
export const UPDATE_MAIL = "/update/mail";
export const SET_FOLDER_SELECTED_MAILS = "/setfolderonmail";
export const STARED_MAIL = "/stared/mail";
export const TRASH_MAIL = "/trash/mail";
export const GET_MAILS_ID = "/mail:id";

//Delete mail
export const DELETE_MAIL = "/mail/delete";

export const GET_EARNING_DATA = "/earning-charts-data";

export const TOP_SELLING_DATA = "/top-selling-data";

//dashboard charts data
export const GET_DASHBOARD_EMAILCHART = "/dashboard/email-chart";

//latest transaction
export const GET_TRANSACTION = "/transaction";

// Wallet Balance
export const GET_WALLENT_BALANCE = "/walletBalance";

// Visitors
export const GET_BLOG_VISITORS = "/blogVisitors";

//statistics Applications
export const GET_STATISTICS_APPLICATION = "/statistics Applications";

//Jobs
export const GET_JOB_LIST = "/jobs";
export const DELETE_JOB_LIST = "/delete/job";
export const ADD_NEW_JOB_LIST = "/job/add";
export const UPDATE_JOB_LIST = "/job/update";

//job grid
export const GET_JOB_GRID = "/job-grid";
//job condidate list
export const GET_CANDIDATE0_LIST = "/condidate-list";

//Apply Jobs
export const GET_APPLY_JOB = "/jobApply";
export const DELETE_APPLY_JOB = "/delete/applyjob";

//Chat
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";

// --------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------------------
// COMENZAR LOS ENDPOINTS DE LA API ACA

export const URL_API_BASE =
  process.env.REACT_APP_PUBLIC_APIURL || "http://192.168.0.98:6900/api/v1";

export const PUBLIC_TOKEN_GENERATE = URL_API_BASE + "/auth/public-token";

export const PUBLIC_POST_CREATE_USER = URL_API_BASE + "/create-user";

export const PUBLIC_LOGOUT = URL_API_BASE + "/auth/logout";

export const REFRESH_TOKEN = URL_API_BASE + "/auth/refresh-token";

export const RESEND_OTP = URL_API_BASE + "/auth/resend-otp";

export const PUBLIC_CREATE_ENTITY_USER = URL_API_BASE + "/register";

// ********************************
// *** RUTAS PUBLICAS ***
// CATALOGOS
export const PUBLIC_GET_COUNTRIES = URL_API_BASE + "/public/countries";
export const PUBLIC_GET_GENDERS = URL_API_BASE + "/public/genders";
export const GET_CURRENCY_TYPE = URL_API_BASE + "/public/currencies";
export const GET_LANGUAGES = URL_API_BASE + "/public/languages";
export const GET_ECONOMIC_ACTIVITIES = URL_API_BASE + "/public/eactivity";
export const GET_STATE_COUNTRIES_TYPE = URL_API_BASE + "/public/statecountries";
export const GET_DOCUMENTS_TYPES = URL_API_BASE + "/public/document-types";
export const GET_COMPANTY_TYPE = URL_API_BASE + "/public/company-types";
export const GET_INCOME_RANGES = URL_API_BASE + "/public/income-range";
export const GET_FUNDS_TYPE = URL_API_BASE + "/public/funds-type";

//VALIDACIONES
export const SEND_INDIVIDUAL_OPT_VERIFICATION =
  URL_API_BASE + "/public/send-otp";
export const VALIDATE_INDIVIDUAL_OTP = URL_API_BASE + "/public/validate-otp";
export const POST_VERIFY_EMAIL = URL_API_BASE + "/public/email-verification";
export const CHECK_REGISTER_PROGRESS = URL_API_BASE + "/public/check-register";
export const SAVE_IMAGES = URL_API_BASE + "/public/save-images";
export const UPLOAD_PDF = URL_API_BASE + "/public/upload-pdf";
export const SAVE_PDF = URL_API_BASE + "/public/save-pdf";
export const UPLOAD_CHUNK = URL_API_BASE + "/public/upload-chunk";
export const COMPLETE_UPLOAD = URL_API_BASE + "/public/complete-upload";

// REGISTER INDIVIDUAL
export const GET_ENTITY_TYPE = URL_API_BASE + "/public/entityType";
export const SAVE_INDIVIDUAL_FIST_STEP =
  URL_API_BASE + "/public/register-first";
export const POST_IDENTITY_VERIFIFCATION =
  URL_API_BASE + "/public/identity-verification";
export const POST_ADDRESS_INFORMATION =
  URL_API_BASE + "/public/address-information";
export const POST_FINANCIAL_INFORMATION =
  URL_API_BASE + "/public/finantial-information";
export const CONTINUE_REGISTER_PROGRESS =
  URL_API_BASE + "/public/continue-register";
export const GET_REGISTER_ENDED = URL_API_BASE + "/public/review-register"; // \?userId=100

export const POST_SUBMIT_REGISTER = URL_API_BASE + "/public/submit-register";

// REGISTRO ENTIDADES
export const POST_COMPANY_FIRST_STEP =
  URL_API_BASE + "/public/company/first-call";
export const POST_BUSINESS_INFORMATION =
  URL_API_BASE + "/public/company/basic-info";
export const POST_LEGAL_DOCUMENTS =
  URL_API_BASE + "/public/company/legal-documentation";
export const POST_SHARE_HOLDERS = URL_API_BASE + "/public/company/shareholders";
export const POST_COMPANY_FINANTIAL_INFO =
  URL_API_BASE + "/public/company/finantial-information";
export const GET_COMPANY_FINAL_INFO =
  URL_API_BASE + "/public/company/review-register";
export const POST_SUBMIT_BUSINESS_REGISTER =
  URL_API_BASE + "/public/company/submit-register";

// ********************
// NUEVO FORMATO PARA GUARDAR ENTIDAD-----------------------------------------

// -----------------------------------------------------------
// AUTH USER
export const POST_LOGIN_USER = URL_API_BASE + "/auth/login";

export const POST_OPT_VERIFIED_LOGIN = URL_API_BASE + "/auth/verify-otp";

export const POST_FORGOT_PASSWORD = URL_API_BASE + "/forgot-password";

export const POST_RESET_PASSWORD = URL_API_BASE + "/reset-password";

export const POST_CREATE_USER = URL_API_BASE + "/private/create-user";

export const UPDATE_USER_ROLES = URL_API_BASE + "/private/update-user/"; //:id

// ENTITIES
export const PIBLIC_POST_ENTITY_DATA = URL_API_BASE + "/create-entity";

export const GET_COUNTRIES = URL_API_BASE + "/private/countries";

export const GET_GENDER = URL_API_BASE + "/private/genders";

export const GET_USERS_ENTITY = URL_API_BASE + "/private/users-entity";

export const GET_ROLES_SYSTEM = URL_API_BASE + "/private/roles";

export const UPDATE_ROLES = URL_API_BASE + "/private/update-role/"; //:id

export const CREATE_ROLES_ENTITY = URL_API_BASE + "/private/create-role";

export const UPDATE_INFO_USER_PROFILE =
  URL_API_BASE + "/private/update-profile";

export const GET_PERMISSIONS = URL_API_BASE + "/private/permissions";

export const GET_USER_BY_ID = URL_API_BASE + "/private/user";

export const CHANGE_STATUS_ROLE = URL_API_BASE + "/private/rol-enabled/"; // :id

export const CHANGE_STATUS_USER = URL_API_BASE + "/private/change-userstatus/"; //:id

export const GET_ACTIVE_ROLES = URL_API_BASE + "/private/active-roles";

export const GET_INFO_ENTITY_LEGALUSER = URL_API_BASE + "/entity-profile";

export const POST_DOCUMENTS_ENTITY = URL_API_BASE + "/create-documents";

export const GET_DOCUMENTS_ENTITY = URL_API_BASE + "/documents";

// --------------------------------
// WALLETS

export const CREATE_WALLET = URL_API_BASE + "/create-wallet";

export const GET_WALLETS_ENTITY = URL_API_BASE + "/wallets";

export const UPDATE_WALLET_INFO = URL_API_BASE + "/update-wallet/"; //:id

export const GET_FIAT_CURRENCIES = URL_API_BASE + "/fiat-currencies";

export const GET_CRYPTO_CURRENCIES = URL_API_BASE + "/crypto-currencies";

export const GET_NETWORKS_WALLETS = URL_API_BASE + "/networks";

export const UPDATE_STATUS_WALLET = URL_API_BASE + "/update-status/"; //id

// --------------------------------------
// BRIDGE

export const GET_ENTITY_TYPE_LOG = URL_API_BASE + "/private/user-information/";
export const CREATE_CUSTOMER_BRIDGE = URL_API_BASE + "/private/create-customer";
export const CREATE_BUSINESS_BRIDGE =
  URL_API_BASE + "/private/create-business-bridge";
